import { createSelector } from 'reselect';
import getNotificationPreferences from './getNotificationPreferences';
const getNotificationPreferencesRequestState = createSelector(getNotificationPreferences, notificationPreferences => notificationPreferences.requestState);
export default getNotificationPreferencesRequestState;